<template>
    <div class="index" :style="height">
        
        <el-container :style="height">
                <el-menu :default-active="menuIndex" :collapse="isCollapse" @select="selectMenu" unique-opened="true" class="el-menu-vertical-demo">
                   

                    <el-menu-item index="100-1" name="控制台" path="console">
                        <i class="el-icon-monitor"></i>
                        <span slot="title">控制台</span>
                    </el-menu-item>


                    <el-submenu :index="item.sortId" v-for="(item,index) in menus" :key="index">
                        <template slot="title">
                            <i :class="item.icon"></i>
                            <span slot="title">{{item.name}}</span>
                        </template>
                        <el-menu-item-group>
                            <el-menu-item :index="item.sortId+'-'+mitem.sortId" :name="item.name+'>'+mitem.name" :path="mitem.path" v-for="(mitem,mindex) in item.children" :key="mindex">
                                {{mitem.name}}
                                <div class="badge">
                                    <el-badge :value="menuNum.zb_xnj" class="mark" type="warning" :max="99" v-if="mitem.path=='caseManageIndex1'"/>
                                    <el-badge :value="menuNum.zb_zyz" class="mark" type="warning" :max="99" v-if="mitem.path=='caseManageIndex2'"/>
                                    <!-- <el-badge :value="menuNum.zb_zyz" class="mark" type="warning" :max="99" v-if="mitem.path=='caseManageIndex3'"/> -->
                                    <el-badge :value="menuNum.zb_ajsh" class="mark" type="warning" :max="99" v-if="mitem.path=='caseManageIndex4'"/>

                                    <el-badge :value="menuNum.rs_xrw" class="mark" type="warning" :max="99" v-if="mitem.path=='caseTaskManageIndex1'"/>
                                    <!-- <el-badge :value="menuNum.rs_ckpg" class="mark" type="warning" :max="99" v-if="mitem.path=='caseTaskManageIndex2'"/> -->
                                    <el-badge :value="menuNum.rs_rsgz" class="mark" type="warning" :max="99" v-if="mitem.path=='caseTaskManageIndex3'"/>
                                    <el-badge :value="menuNum.rs_cksh" class="mark" type="warning" :max="99" v-if="mitem.path=='caseTaskManageIndex4'"/>
                                    
                                    <!-- <el-badge :value="menuNum.rs_fash" class="mark" type="warning" :max="99" v-if="mitem.path=='caseTaskManageIndex5'"/>
                                    <el-badge :value="menuNum.rs_zbth" class="mark" type="warning" :max="99" v-if="mitem.path=='caseTaskManageIndex6'"/> -->
                                    <el-badge :value="menuNum.rs_zpckz" class="mark" type="warning" :max="99" v-if="mitem.path=='surveyNoCompleted'"/>
                                    <el-badge :value="menuNum.rs_ckwc" class="mark" type="warning" :max="99" v-if="mitem.path=='surveyCompleted'"/>


                                    <el-badge :value="menuNum.tj_fazzz" class="mark" type="warning" :max="99" v-if="mitem.path=='mediationTaskManageIndex2'"/>
                                    <el-badge :value="menuNum.tj_fath" class="mark" type="warning" :max="99" v-if="mitem.path=='mediationTaskManageIndex3'"/>
                                    <el-badge :value="menuNum.tj_xyqsz" class="mark" type="warning" :max="99" v-if="mitem.path=='mediationTaskManageIndex4'"/>


                                    <el-badge :value="menuNum.cky_xck" class="mark" type="warning" :max="99" v-if="mitem.path=='surveyTaskManageIndex1'"/>
                                    <el-badge :value="menuNum.cky_ckz" class="mark" type="warning" :max="99" v-if="mitem.path=='surveyTaskManageIndex2'"/>
                                    <el-badge :value="menuNum.cky_shth" class="mark" type="warning" :max="99" v-if="mitem.path=='surveyTaskManageIndex3'"/>

                                </div>
                            </el-menu-item>
                            

                        </el-menu-item-group>
                    </el-submenu>
                </el-menu>
            <!-- </transition> -->
            <!-- <transition name="elcontainer"> -->
                <!--  :class="!isCollapse ? 'container-all container' : 'container'" -->
                <el-container class="container">
                    <el-header >
                        <div class="header-top">
                            <div class="header">
                                <div class="l">
                                    <img src="../../assets/images/icon05.png" alt="" srcset="" v-if="!isCollapse" @click="showMenu">
                                    <img src="../../assets/images/icon05x.png" alt="" srcset="" v-else  @click="showMenu">
                                    <div class="breadcrumb">
                                    <!-- :to="{ name: 'console' }" -->
                                        <el-breadcrumb separator-class="el-icon-arrow-right" style="margin-left:30px;">
                                            <el-breadcrumb-item  v-for="(item,index) in nameList" :key="index">{{item}}</el-breadcrumb-item>
                                        </el-breadcrumb>
                                    </div>
                                </div>
                                <div class="r">
                                    <el-popover
                                        placement="bottom"
                                        title="操作手册"
                                        width="110"
                                        trigger="hover"
                                        >
                                        <div class="document-btns">
                                            <div>
                                                <el-button icon="el-icon-share" type="text" @click="operationManual(1)">人伤系统使用说明书</el-button>
                                            </div>
                                        </div>
                                        
                                        <el-button slot="reference" type="text" icon="el-icon-document" size="" style="margin-right:20px;font-size: 18px;color:#000000"></el-button>
                                    </el-popover>
                                    <el-button type="text" icon="el-icon-aim" size="" style="font-size: 18px;color:#000000" @click="aim" v-if="isFullScreen"></el-button>
                                    <el-button type="text" icon="el-icon-full-screen" size="" style="font-size: 18px;color:#000000" @click="fullScreen" v-else></el-button>
                                    <el-button type="text" icon="el-icon-setting" style="margin-right:10px;margin-left:20px;font-size: 18px;color:#000000" @click="goUpdatePassword"></el-button>
                                    <el-button type="text" icon="el-icon-switch-button" @click="quit" style="margin-right:20px;font-size: 18px;color:#000000"></el-button>
                                    <!-- <span class="r-span">欢迎<span class="name">admin</span>来到意健险系统!</span>  -->
                                    <img src="../../assets/images/user.png" alt="">
                                    <span class="r-span"><span class="name">您好！{{name}}</span></span> 
                                </div>
                            </div>
                        </div>
                        
                        <!-- <div class="tabs">
                            <div class="tabs-l">
                                <el-tabs v-model="tabsValue" type="card" closable @tab-remove="removeTab" @tab-click="clickTab">
                                    <el-tab-pane
                                        v-for="(item, index) in tabs"
                                        :key="index"
                                        :label="item.title"
                                        :name="item.path"
                                    >
                                        <span slot="label" v-if="index==0"><i class="el-icon-s-platform" style="margin-right:4px"></i>控制台</span>
                                    </el-tab-pane>
                                </el-tabs>
                            </div>
                            <div class="tabs-r">
                                <i class="el-icon-menu"></i>
                                <div class="handle">
                                    <div class="handle-item" @click="closeTabOther">
                                        <i class="el-icon-close"></i>
                                        关闭其他
                                    </div>
                                    <div class="handle-item" @click="closeTabLeft">
                                        <i class="el-icon-back"></i>
                                        关闭左侧
                                    </div>
                                    <div class="handle-item" @click="closeTabRight">
                                        <i class="el-icon-right"></i>
                                        关闭右侧
                                    </div>
                                    <div class="handle-item" @click="closeTabAll">
                                        <i class="el-icon-close"></i>
                                        关闭全部
                                    </div>
                                </div>
                            </div>
                            
                        </div> -->
                    </el-header>
                    
                    <el-main>
                        <!-- <keep-alive> -->
                            <router-view @addAnXinCase="addAnXinCase"></router-view>
                        <!-- </keep-alive> -->
                    </el-main>
                </el-container>
            <!-- </transition> -->
        </el-container>
    </div>
</template>
<script>
import api from '../../api/main'
import App from '../../App.vue';
import store from '../../store';
export default {
  components: { App },
    name: 'index',
    data () {
        return {
            height:'100%',
            isCollapse:false,
            nameList:['控制台'],
            tabs:[{
                title: '控制台',
                path: 'console',
            }],
            tabsValue:'console',
            menus:[],
            role:'',
            menuIndex:0,
            parentMenuIndex:0,
            isFullScreen:false,
            roleName:'',
            name:localStorage.getItem('name'),
            menuNum:{},
        }
    },
    created(){
        

    },
    mounted(){
        this.getUserMenu();
        this.messageCountCK_Message();
        this.getHeight();
        window.addEventListener("keydown", this.KeyDown, true);

        if(store.getters['global/s_tabs'].length>0){
            this.tabs = store.getters['global/s_tabs'];
        }
        if(store.getters['global/s_tabsValue']){
            this.tabsValue = store.getters['global/s_tabsValue'];
            console.log(this.tabsValue);
            for(let index in this.tabs){
                if(this.tabsValue == this.tabs[index].path){
                    this.menuIndex = this.tabs[index].index;
                    this.parentMenuIndex = this.menuIndex.split('-')[0];
                }
            }
            // this.menuIndex = this.tabs[e.index].index;

        }

        if(localStorage.getItem('roleName')){
            this.roleName = localStorage.getItem('roleName');
        }
    },
    methods:{
       
        operationManual(index){
            if(index==1){
                window.open('http://120.24.255.164:4999/web/#/19/99');
            }
        },

        addAnXinCase(event){
            console.log(event);
            console.log(this.tabs);
            this.nameList=[event.name]
            let isRepetition = false;
            for(let i in this.tabs){
                if(this.tabs[i].index==event.index){
                    isRepetition=true;
                }
            }
            console.log(isRepetition);
            if(isRepetition){

            }else{
                this.tabs.push({
                    title: event.name,
                    path: event.router,
                    nameList:this.nameList,
                    index:event.index,
                    id:event.id
                });
            }
            
            this.tabsValue = event.router;
            store.dispatch('global/setTabs', this.tabs);
            store.dispatch('global/setTabsValue', this.tabsValue);
        },

        // 获取菜单
        async getUserMenu(){
            let res  = await api.queryResource();
            this.menus = res.data.data;
        },
        // 关闭其他
        closeTabOther(){
            for(let i = 1;i<this.tabs.length;i++){
                if(this.tabs[i].path == this.tabsValue){
                    this.tabs = [this.tabs[0],this.tabs[i]]
                }else{
                }
            }
            store.dispatch('global/setTabs', this.tabs);
            store.dispatch('global/setTabsValue', this.tabsValue);
        },    
        closeTabLeft(){
            for(let i = 1;i<this.tabs.length;){
                if(this.tabs[i].path == this.tabsValue){
                    store.dispatch('global/setTabs', this.tabs);
                    store.dispatch('global/setTabsValue', this.tabsValue);
                    return;
                }else{
                    this.tabs.splice(i,1);
                }
            }
        },
        closeTabRight(){
            let startIndex = 1;
            for(let i = 1;i<this.tabs.length;i++){
                if(this.tabs[i].path == this.tabsValue){
                    startIndex = i+1;
                    continue;
                }
            }
            for(startIndex;startIndex<this.tabs.length;){
                this.tabs.splice(startIndex,1);
            }
            store.dispatch('global/setTabs', this.tabs);
            store.dispatch('global/setTabsValue', this.tabsValue);
        },
        closeTabAll(){
            this.tabs = [this.tabs[0]];
            this.tabsValue = this.tabs[0].path;
            this.parentMenuIndex = 0;
            this.nameList = ['控制台'];
            
            this.$router.push({name:this.tabsValue});
            this.menuIndex = this.tabs[0].index
            store.dispatch('global/setTabs', this.tabs);
            store.dispatch('global/setTabsValue', this.tabsValue);
        },
        //获取浏览器的当前的高度
        getHeight(){
            let _this = this;
            _this.height =  'height:'+document.body.clientHeight+'px';
            window.onresize = function(){
                _this.height =  'height:'+document.body.clientHeight+'px';
                // 是否全屏
                // if(!_this.isFullScreen){
                //     _this.isFullScreen=true;
                // }
            }
        },
        // 选择左侧菜单
        selectMenu(index,path,route){
            console.log('route')
            console.log(route)
            this.messageCountCK_Message();
            this.nameList = route.$attrs.name.split('>');
            this.menuIndex = index;
            this.parentMenuIndex = this.menuIndex.split('-')[0];
            localStorage.setItem('taskStatus',this.menuIndex.split('-')[1]);
            this.$router.push({name:route.$attrs.path});
            for(let i=0;i<this.tabs.length;i++){
                if(this.tabs[i].path == route.$attrs.path){
                    this.tabsValue = route.$attrs.path;
                    store.dispatch('global/setTabsValue', this.tabsValue);
                    return;
                }
            }
            this.tabs.push({
                title: this.nameList[0]+'-'+this.nameList[this.nameList.length-1],
                path: route.$attrs.path,
                index:index,
                nameList:this.nameList,
            });
            this.tabsValue = route.$attrs.path;
            store.dispatch('global/setTabs', this.tabs);
            store.dispatch('global/setTabsValue', this.tabsValue);
           
        },
        goUpdatePassword(){
            this.$router.push({name:'updatePassword'});
        },
        // 显示隐藏菜单栏
        showMenu(){
            this.isCollapse = !this.isCollapse
        },
        
        // 切换tab
        clickTab(e){
            console.log(e);
            console.log(this.tabs[e.index]);
            if(this.tabs[e.index].id&&this.tabs[e.index].anXinDcTaskId){
                this.$router.push({
                    name:this.tabs[e.index].path,
                    query:{
                        id:this.tabs[e.index].id,
                        anXinDcTaskId:this.tabs[e.index].anXinDcTaskId,
                    }
                });
            }else if(this.tabs[e.index].id&&!this.tabs[e.index].anXinDcTaskId){
                this.$router.push({
                    name:this.tabs[e.index].path,
                    query:{
                        id:this.tabs[e.index].id
                    }
                });
            }else{
                this.$router.push({name:this.tabs[e.index].path});
            }
            this.menuIndex = this.tabs[e.index].index;
            if(this.menuIndex){
                this.parentMenuIndex = this.menuIndex.split('-')[0];
                localStorage.setItem('taskStatus',this.menuIndex.split('-')[1]);
                this.nameList = this.tabs[e.index].nameList;
            }else{
                this.parentMenuIndex = 0;
                this.nameList = ['控制台']
            }
            store.dispatch('global/setTabsValue', this.tabsValue);
        },
        // 关闭tab
        removeTab(targetName){
            console.log(targetName);
            if(this.tabsValue === targetName){
                this.tabs.forEach((tab,index) => {
                    if(tab.path === targetName) {
                        console.log(this.tabs[index-1]);
                        this.menuIndex = this.tabs[index-1].index ? this.tabs[index-1].index : 0;
                        if(this.menuIndex == 0){
                            this.parentMenuIndex = 0;
                        }
                        this.tabsValue = this.tabs[index-1].path;
                        this.$router.push({name:this.tabsValue});
                        this.nameList = this.tabs[index-1].nameList?this.tabs[index-1].nameList:['控制台'];
                        return;
                    }
                })
            }
            this.tabs = this.tabs.filter(tab => tab.path !== targetName);
            store.dispatch('global/setTabs', this.tabs);
            store.dispatch('global/setTabsValue', this.tabsValue);
        },
        // 退出登录
        quit(){
            this.$confirm('将退出登录, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$message({
                    type: 'success',
                    message: '退出成功!'
                });
                store.dispatch('global/setTabs', []);
                store.dispatch('global/setTabsValue', '');
                this.$router.push({ name: 'login' });
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消退出'
                });          
            });
        },
        // 全屏
        fullScreen(){
            var docElm = document.documentElement;  
            //W3C   
            if (docElm.requestFullscreen) {  
                docElm.requestFullscreen();  
            }  
                //FireFox   
            else if (docElm.mozRequestFullScreen) {  
                docElm.mozRequestFullScreen();  
            }  
                //Chrome等   
            else if (docElm.webkitRequestFullScreen) {  
                docElm.webkitRequestFullScreen();  
            }  
                //IE11   
            else if (elem.msRequestFullscreen) {  
                elem.msRequestFullscreen();  
            }  
            this.isFullScreen = true;
        },
        aim(){
            if (document.exitFullscreen) {  
                document.exitFullscreen();  
            }  
            else if (document.mozCancelFullScreen) {  
                document.mozCancelFullScreen();  
            }  
            else if (document.webkitCancelFullScreen) {  
                document.webkitCancelFullScreen();  
            }  
            else if (document.msExitFullscreen) {  
                document.msExitFullscreen();  
            }  
            this.isFullScreen = false;

        },
        
        async messageCountCK_Message(){
            let res = await api.messageCountCK_Message();
            this.menuNum = res.data.data;
        },
    }
    
}
</script>

<style lang="scss" scoped>
   
    .index{
        background-color: #F5F7F9;
        min-height: 100%;
        
        .document-btns{
            display: flex;
            flex-direction: column;
            align-items: center;
        }
        /deep/.el-container{
            flex: 1;
        }
        /deep/.el-menu{
            overflow: hidden;
        } 
        /deep/.el-menu-item{
            display: flex;
            align-items: center;
            .badge{
                height: 50px;
                margin-bottom: 16px;
                margin-left: 4px;
            }
        }
        /deep/.el-menu-item-group__title{
            padding:0;
        } 
        /deep/.el-header{
            height: 60px !important;
            padding: 0;
            
            .header-top{
                width: 100%;
                height: 60px;
                background-color: #F5F7F9;
            }
            .header{
                background-color: #FFFFFF;
                width: 100%;
                height: 50px;
                margin-bottom: 2px;
                // border-bottom: 1px solid #DEDEDE;
                display: flex;
                align-items: center;
                justify-content: space-between;
                box-shadow: 0 1px 4px rgba(0,21,41,.08);

                .l{
                    height: 21px;
                    margin-left: 15px;
                    display: flex;
                    align-items: center;
                    img{
                        width: 20px;
                        height: 16px;
                        cursor: pointer;
                    }

                    .breadcrumb{
                        background-color: #FFFFFF;
                        height: 40px;
                        display: flex;
                        align-items: center;
                        margin-left: 10px;
                        .el-breadcrumb{
                            margin-left: 15px!important;
                            .el-breadcrumb__inner{
                                font-size: 15px;
                                // font-weight: bold;
                                color: #000000 !important;
                            }
                        }
                        
                    }
                }
                .r{
                    height:46px;
                    display: flex;
                    align-items: center;
                    .r-span{
                        line-height: 46px;
                        margin-right: 20px;
                        font-size: 14px;
                        .name{
                            color: #409EFF;
                            margin-right: 0;
                        }
                       
                    }
                    img{
                        width: 26px;
                        margin-right: 4px;
                        margin-top: 2px;
                    }
                    /deep/.el-button{
                        i{
                            font-size: 16px !important;
                        }
                    }
                }
                .popover{
                    width: 100px;
                    border:1px solid #ffffff;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                }
            }
            .tabs{
                background-color: #FFFFFF;
                padding: 10px;
                box-shadow: 0 1px 4px rgba(0,21,41,.08);
                height: 36px;
                display: flex;
                justify-content: space-between;
                align-items: center;
                position: relative;
                // border-bottom: 1px solid #DEDEDE;
                .el-tabs--card>.el-tabs__header{
                    border: 0;
                }
                .el-tabs--card>.el-tabs__header .el-tabs__nav{
                    border: 0;
                    background-color: #FFFFFF;
                }
                .el-tabs__header{
                    margin: 0;
                }
                .el-tabs--card>.el-tabs__header .el-tabs__item{
                    border: 1px solid #e4e7ed;
                    border-radius: 5px;
                    margin-right: 10px;
                    height: 36px;
                    line-height: 36px;
                    padding: 0 18px;
                }
                .el-tabs__nav .el-tabs__item:nth-child(1) .el-icon-close{
                    display: none;
                }
                .el-tabs{
                    padding-right: 30px;
                }
                .el-tabs__nav-next, .el-tabs__nav-prev{
                    line-height: 35px;
                }
                .tabs-l{
                    width: 100%;
                }
                .tabs-r{
                    height: 40px;
                    display: flex;
                    align-items: center;
                    font-size: 20px;
                    position:absolute;
                    right: 12px;
                    cursor: pointer;
                    .i{
                        font-size: 24px;
                    }
                }
                .handle{
                    // border: 1px solid #000000;
                    display: none;
                    width: 100px;
                    height: 100px;
                    position: absolute;
                    right: 2px;
                    top: 30px;
                    z-index: 9999;
                    background-color: #ffffff;
                    box-shadow: 0 2px 12px 0 rgba(163, 163, 163, 0.363);
                    padding: 6px 0;
                    transition: .3s;
                }

                .handle-item{
                    padding-left: 12px;
                    height: 25px;
                    line-height: 22px;
                    font-size: 13px;
                    color: #222222;
                    cursor: pointer;
                    transition: .3s;
                    i{
                        font-size: 14px;
                    }
                }
                .tabs-r:hover .handle{
                    display: block;
                }
                .handle-item:hover{
                    color: #409EFF;
                }
            }
        }
        /deep/.el-main{
            padding: 10px;
            padding-top: 0px;
        }
        /deep/.el-menu--collapse{
            width: 64px;
        } 
        /deep/.el-submenu__title{
            width: 200px;
        }
        .el-menu-vertical-demo:not(.el-menu--collapse) {
            width: 200px;
            min-height: 400px;
        }
    }
    
  
</style>
